// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__IG5js","active":"styles_active__O27r3"};